import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';

import * as noiseAlertsActions from '../../actions/NoiseAlertsActions';
import { getAddressByLatLong } from '../../actions/GlobalsActions';
import AddNoiseAlertForm from '../../components/AlertsSettings/AddNoiseAlertForm';
const _ = require('lodash');

const getInitialValues = (options) => {
  let initialValues = null;

  if (options && !_.isEmpty(options)) {
    const dateNow = new Date();
    const dateNowString = dateNow.toISOString().split('T')[0];

    const defultABC = options.ABC.find((optionItem, index, allOptions) => optionItem.label == 'A');
    // const defultAlertState = options.AlertState.find((optionItem, index, allOptions) => optionItem.value == 6); //'Fixed'
    const defultAlertType = options.AlertType.find((optionItem, index, allOptions) => optionItem.label == 'Leak');

    initialValues = {
      DetectionDateTime: dateNowString,
      fixDate: dateNowString,
      ABC: defultABC.value,
      AlertType: defultAlertType.value,
      // AlertState: defultAlertState.value,
    };
  }

  return (initialValues);
};

const mapStateToProps = (state, ownProps) => {
  const user = state.leaksList.user;
  const optionList = state.leaksList.optionList.options;
  const { WorkAreas = [], ContractorID = [], PCARepairCodesEnum = [], AlertStateNoise = [], AlertType = [], ABC = [] } = optionList;

  // Filter out D option without mutating the original array
  const filteredABC = ABC.filter((opt) => opt.label !== 'D');

  // const alertStatuses = AlertState.filter((status) => {
  //   return status.label == 'Fixed' || status.label == 'To be Fixed';
  // });

  const selectedProjectId = state.leaksList.selectedProject;
  let projectCouples = [];
  if (state.leaksList.leaksByProject[selectedProjectId] && state.leaksList.leaksByProject[selectedProjectId].couples) {
    projectCouples = state.leaksList.leaksByProject[selectedProjectId].couples.couples;
  }

  const couplesIdsData = projectCouples.map((couple, index, array) => {
    const coupleId = couple.id;
    const address1 = couple.Address1;
    const address2 = couple.Address2;
    return {
      label: `${coupleId}:  ${address1} / ${address2}`,
      value: coupleId
    };
  });

  // let initialValues = getInitialValues(optionList);

  return Object.assign({}, {
    user,
    options: {
      WorkAreas,
      ContractorID,
      PCARepairCodesEnum,
      // AlertState,
      AlertType,
      ABC: filteredABC
    },
    AlertStateNoise,
    couplesIdsData,
    // initialValues
  }, ownProps);
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    doClose: () => {
      ownProps.showAddAlertForm(false);
    },
    onSubmit: (values, dispatch, props) => {
      const requiredFields = ['InsertDate', 'CreateDate', 'AlertState'];

      requiredFields.forEach((fieldKey) => {
        if (values[fieldKey] == null || values[fieldKey] === '') {
          throw new SubmissionError({
            [fieldKey]: 'Require',
            _error: fieldKey + ' is Require'
          });
        }
      });
        dispatch(noiseAlertsActions.createNewNoiseAlert(values, ownProps.notify));
    },
    getAddressByLatLong: () => {
      dispatch(getAddressByLatLong('add-alert', 'StreetAddress'));
    },
    onCreateNewValue: (valueKey, value) => {
      // dispatch(alertsActions.addLeakOption(valueKey, value));
    }
  };
};

const CAddAlert = connect(
  mapStateToProps,
  mapDispatchToProps
)(AddNoiseAlertForm);

export default CAddAlert;
